import Instagram from "./instagram.container";

export default Instagram;
